import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';

export const StyledHeaderTitle = styled(Typography)`
    ${({ theme }) => `
    display: inline-block;
    font-weight: 600;
    font-size: 2rem;
    color: ${theme.palette.primary.main};
    `}
`;

export const StyledTitle = styled(Typography)`
    ${({ theme, $fontSize, $lineHeight, $ellipsis, $lineClamp = 2 }) => `
    color: ${theme.palette.common.black};
    font-size: ${$fontSize || '1.5rem'};
    font-weight: 600;
    line-height: ${$lineHeight ? $lineHeight : 'inherit'};

    ${
        $ellipsis &&
        `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: ${$lineClamp}; 
    -webkit-box-orient: vertical;
    `
    }
    `}
`;

export const StyledSubtitle = styled(Typography)`
    ${({ theme, margin, padding, $textColor }) => `
color: ${$textColor ? theme.palette.common[$textColor] : theme.palette.common.gray2};
margin: ${margin ? margin : 0};
padding: ${padding ? padding : 0};
`}
`;

export const StyledText = styled(Typography)`
    ${({ theme, $color, $bold, $medium, $fontSize, $ellipsis, onClick, $lineClamp, disabled }) => `
    color:${$color ? theme.palette.common[$color] : theme.palette.common.black};
    font-weight: ${$bold ? '600' : $medium ? '500' : '400'};
    font-size: ${$fontSize ? $fontSize : '16px'};
    cursor: ${disabled ? 'not-allowed' : onClick ? 'pointer' : 'inherit'};

    &:hover {
        text-decoration: ${disabled ? 'none' : onClick ? 'underline' : 'none'};
    }

    ${
        $ellipsis
            ? `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: ${$lineClamp ? $lineClamp : 2}; 
    -webkit-box-orient: vertical;
    `
            : ''
    }

    `}
`;

export const StyledSpan = styled(Typography)`
    ${({ theme, $color, $bold, $fontSize }) => `
    color:${$color ? theme.palette.common[$color] : 'inherit'};
    font-weight: ${$bold ? '600' : 'inherit'};
    font-size: ${$fontSize ? $fontSize : 'inherit'};
    `}
`;
